/**
 * @flow
 * @relayHash 568429a2c7e74c26b4018ca8fe9818bd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MusicPlannerContainer_node$ref = any;
export type UpdatePlannerPlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type MusicPlannerComponent_UpdatePlannerPlaylistMutationVariables = {|
  input: UpdatePlannerPlaylistInput
|};
export type MusicPlannerComponent_UpdatePlannerPlaylistMutationResponse = {|
  +updatePlannerPlaylist: ?{|
    +music_planner: ?{|
      +$fragmentRefs: MusicPlannerContainer_node$ref
    |}
  |}
|};
export type MusicPlannerComponent_UpdatePlannerPlaylistMutation = {|
  variables: MusicPlannerComponent_UpdatePlannerPlaylistMutationVariables,
  response: MusicPlannerComponent_UpdatePlannerPlaylistMutationResponse,
|};
*/


/*
mutation MusicPlannerComponent_UpdatePlannerPlaylistMutation(
  $input: UpdatePlannerPlaylistInput!
) {
  updatePlannerPlaylist(input: $input) {
    music_planner {
      ...MusicPlannerContainer_node
      id
    }
  }
}

fragment MusicPlannerContainer_node on MusicPlanner {
  id
  title
  description
  notes
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  planner_playlists(first: 99999) {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlannerPlaylistInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdatePlannerPlaylistInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "MusicPlannerComponent_UpdatePlannerPlaylistMutation",
  "id": null,
  "text": "mutation MusicPlannerComponent_UpdatePlannerPlaylistMutation(\n  $input: UpdatePlannerPlaylistInput!\n) {\n  updatePlannerPlaylist(input: $input) {\n    music_planner {\n      ...MusicPlannerContainer_node\n      id\n    }\n  }\n}\n\nfragment MusicPlannerContainer_node on MusicPlanner {\n  id\n  title\n  description\n  notes\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  planner_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MusicPlannerComponent_UpdatePlannerPlaylistMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlannerPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlannerPlaylistPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "music_planner",
            "storageKey": null,
            "args": null,
            "concreteType": "MusicPlanner",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "MusicPlannerContainer_node",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MusicPlannerComponent_UpdatePlannerPlaylistMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlannerPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlannerPlaylistPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "music_planner",
            "storageKey": null,
            "args": null,
            "concreteType": "MusicPlanner",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_email",
                "args": null,
                "storageKey": null
              },
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              },
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "share_token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_logo_url",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_header",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "planner_playlists",
                "storageKey": "planner_playlists(first:99999)",
                "args": v5,
                "concreteType": "PlannerPlaylistConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PlannerPlaylistEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PlannerPlaylist",
                        "plural": false,
                        "selections": [
                          v2,
                          v4,
                          v3,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "thumbnail",
                            "storageKey": "thumbnail(height:240,width:240)",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "height",
                                "value": 240,
                                "type": "Int"
                              },
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 240,
                                "type": "Int"
                              }
                            ],
                            "concreteType": "SongImage",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "url",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "width",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "height",
                                "args": null,
                                "storageKey": null
                              },
                              v2
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "num_songs",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__typename",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "planner_playlists",
                "args": v5,
                "handle": "connection",
                "key": "MusicPlannerContainer_planner_playlists",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workspaces",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkspaceConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkspaceEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Workspace",
                        "plural": false,
                        "selections": [
                          v2,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "event",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Event",
                            "plural": false,
                            "selections": [
                              v2,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "user_contacts",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "EventUserContactConnectionWithRole",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EventUserContactEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "UserContact",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "first_name",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "last_name",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user_contact_emails",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserContactEmailConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "edges",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "UserContactEmailEdge",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "UserContactEmail",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "address",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      v2
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          v2
                                        ]
                                      },
                                      v2
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '37be6231ee99f898b35f681037b445b1';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/MusicPlanner/__generated__/MusicPlannerComponent_UpdatePlannerPlaylistMutation.graphql.js